import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import SidebarSubSection from 'components/Onboarding/PWMSidebar/SidebarSubSection/SidebarSubSection'
import {
  successorDonor as successorDonorConfig
} from 'utils/contactTypes'
import C from 'actionTypes/routing'

const CharitableAccountFormSection = (props) => {
  const {
    financialAccountType,
    financialAccountId,
    sectionsOverview,
  } = props
  const sharedProps = {
    financialAccountType,
    financialAccountId,
  }

  return (
    <Fragment>
      <SidebarSubSection
        sectionComplete={sectionsOverview.accountDetails.complete}
        to={{
          type: C.ONBOARDING_ACCOUNT_DETAILS,
          payload: sharedProps
        }}
        name="Details" />
      <SidebarSubSection
        sectionComplete={sectionsOverview.beneficiaries.complete}
        to={{
          type: C.ONBOARDING_CONTACTS_PAGE,
          payload: {
            ...sharedProps,
            contactType: successorDonorConfig.routeType,
          }
        }}
        name="Successor Donor" />
    </Fragment>
  )
}

CharitableAccountFormSection.propTypes = {
  financialAccountId: PropTypes.string.isRequired,
  financialAccountType: PropTypes.string.isRequired,
  financialAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  sectionsOverview: PropTypes.object.isRequired,
}

export default CharitableAccountFormSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/FinancialAccountFormGroup/FinancialAccountFormSection/CharitableAccountFormSection.jsx